import { RecordsAreaItem } from "../fetching/types/record-areas.item";
import { LoggerService } from "../logger/logger-service";
import { LocatorInterface } from "../interfaces/locator.interface";
import { DatabaseService } from "../wa-services/database-service";
import { Observable } from "rxjs";
import { ResponseData } from "../fetching/wa-response/wa-api-response";
import { ViewDataConfigStruct } from "../interfaces/view-data.interface";
import { ViewData } from "./view-data";
import { FactoryService } from "../wa-services/factory-service";
import { WaHelperService } from "../wa-services/wa-helper-service";
import { DataFetchService } from "../wa-services/data-fetch-service";

export class RecordAreasListVD extends ViewData<RecordsAreaItem> {
  constructor(
    protected logger: LoggerService,
    protected fetchSrvc: DataFetchService,
    protected db: DatabaseService,
    protected _locator: LocatorInterface,
    protected factory: FactoryService,
    protected _helper: WaHelperService
  ) {
    super(logger, db, _locator);
  }
  public configureView() {
    const viewDataConf = new ViewDataConfigStruct();
    viewDataConf.maxAge = 3600 * 6;
    viewDataConf.expectedItems = 10;
    this.applyConfiguration(viewDataConf);
  }
  public updateData(): Observable<ResponseData> {
    return this.fetchSrvc.requestRecordsArea(this.locator, this.pageInfo());
  }
  public mapItem(rawItem: any): RecordsAreaItem {
    return new RecordsAreaItem(rawItem);
  }
}
